/**
 * Created by mac on 7/22/17.
 */

// eslint-disable-next-line
var Counter = function () {
    this.value = 0;

    this.onceZero = undefined;
    this.stages = [];

    this.off = false;

    this.onStageActivatedListener = function () {};
};

// not registered same stage twice
Counter.prototype.registerStage = function (priority, handler) {
    for (let i = 0; i < this.stages.length; i++) {
        if (this.stages[i].handler === handler) {
            return;
        }
    }

    if (cleverapps.config.debugMode) {
        if (this.stages.filter((stage) => stage.priority === priority).length > 0) {
            alert(`Multiple stages with same priority: ${priority}`);
        }
    }

    this.stages.push({
        priority,
        handler
    });

    this.stages.sort((a, b) => a.priority - b.priority);
};

Counter.prototype.runStages = function () {
    if (this.value !== 0 || this.off) {
        return;
    }

    for (let i = 0; i < this.stages.length; i++) {
        this.stages[i].handler();

        if (this.isActive()) {
            this.onStageActivatedListener();
            return;
        }
    }
};

Counter.prototype.turnOff = function () {
    this.off = true;
};

Counter.prototype.turnOn = function () {
    this.off = false;
};

Counter.prototype.isActive = function () {
    return this.value > 0 || this.off === true;
};

Counter.prototype.trigger = function (delay) {
    if (this.off) {
        return;
    }

    if (delay) {
        cleverapps.timeouts.setTimeout(this.trigger.bind(this), delay);
    } else {
        this.runStages();
    }
};

Counter.prototype.inc = function () {
    this.value++;
};

Counter.prototype.dec = function () {
    this.value--;

    if (this.value === 0 && !this.off) {
        if (this.onceZero) {
            const f = this.onceZero;
            this.onceZero = undefined;
            f();
        }
        if (this.value === 0 && !this.off) {
            this.runStages();
        }
    }
};

Counter.prototype.playActions = function (actions) {
    this.inc();

    this._playActions(actions, this.dec.bind(this));
};

Counter.prototype._playActions = function (actions, callback) {
    let action = actions.shift();

    action(() => {
        if (this.off || !actions) {
            return;
        }

        const remains = actions;
        actions = undefined;
        action = undefined;

        if (remains.length === 0) {
            callback();
        } else {
            this._playActions(remains, callback);
        }

        callback = undefined;
    });
};

Counter.prototype.createDelayAction = function (delay) {
    return function (callback) {
        cleverapps.timeouts.setTimeout(callback, delay);
    };
};

Counter.prototype.setTimeout = function (func, delay) {
    this.playActions([this.createDelayAction(delay), function (callback) {
        func();
        callback();
    }]);
};

Counter.prototype.clearStages = function () {
    this.stages = [];
};